import React from "react";

export const BookingNumberCell = ({
  bookingNumber,
}: {
  bookingNumber: string | number;
}) => {
  return <div className="text-center">{bookingNumber}</div>;
};
